/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { buildCategoryEventName } from '../utils/buildCategoryEventName';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY } from '../../../../constants';

// Action for Cabinet Visualizer: (overlay event)
export default (set, get, payload) => {
  const { eventName } = payload;
  set(produce(get(), (draft) => {
    if (!draft.digitalData) {
      draft.digitalData = { event: [] };
    }

    const { category, eventInfo } = buildCategoryEventName('overlay', eventName);
    const event = {
      category,
      eventInfo,
    };

    const eventClone = _cloneDeep(event);
    draft.digitalData.event.push(event); // store cumulative event
    setTimeout(() => {
      Analytics.sendAnalyticsEvent(eventClone);
    }, ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY);
  }), false, { type: 'CHOOSE_CABINET_COLLECTION_EVENT' });
};
